module.exports = __webpack_public_path__ + "img/client-putin_en.3b343348.svg";